import React from 'react'

import Input from 'components/Input'

import './style.scss'


export default function SearchInput(props) {
  const {...inputProps} = props
  return (
    <div className="SearchInput">
      <Input
        icon="search"
        iconAlign="right"
        {...inputProps}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/SearchInput/index.js